export default {
  coming_soon: "เร็ว ๆ นี้...",
  virtual_games: "เสมือนจริง",
  support: "ติดต่อเรา",
  bet_limit: "วงเงินเดิมพัน",
  favorites: "แต้มต่อ",
  note: "หมายเหต",
  my_bets: "บิลเดิมพัน",
  my_account: "บัญชีของฉัน",
  contact_us: "ติดต่อเรา",
  report: "รายงาน",
  help_support: "ช่วยเหลือและสนับสนุน",
  currency: "สกุลเงิน",
  others: "อื่นๆ",
  welcome: "ยินดีต้อนรับ",
  account_id: "ชื่อผู้ใช้",
  password: "รหัสผ่าน",
  account: "บัญชี",
  all_sports: "กีฬาทั้งหมด",
  my_sports: "กีฬา",
  action: "แอ็คชั่น",
  accept_better_odds: "ยอมรับอัตราเดิมพันที่ดีกว่า",
  accept_any_odds: "รับค่าเป็นต่อ ทุกค่า",
  auto_refresh_odds: "รีเฟรชอัตโนมัติ",
  auto_refresh: "รีเฟรชอัตโนมัติ",
  auto_refreshing: "อัตโนมัติกำลังอัพเดต...",
  all_markets: "ตลาดทั้งหมด",
  away: "ทีมเยือน",
  all: "ทั้งหมด",
  accepted: "ยอมรับ",
  add_to_parlay: "เพิ่มไปยังพาร์เลย์",
  add_to_booster: "เพิ่มใน Booster",
  amount: "จำนวน",
  amount_before_balance: "จำนวนก่อนคงเหลือ",
  amount_after_balance: "จำนวนหลังจากยอดคงเหลือ",
  bet_slip: "บิลเดิมพัน",
  bet_credit: "เครดิตพนัน",
  bet_list: "รายการ",
  betting: "การเดิมพัน",
  balance: "ยอดคงเหลือ",
  betting_statement: "ย้อนดูรายการเดิมพันที่เล่นไปแล้ว",
  bet_types: "ประเภทของการเดิมพัน",
  bet_type: "ประเภทของการเดิมพัน",
  bs: "B/S",
  bet_summary: "สรุปการเดิมพัน",
  bet_reject: "เดิมพันเป็นโมฆะ",
  bets: "เดิมพัน",
  bet: "เดิมพัน",
  booster: "Boost",
  casino: "คาสิโน",
  mini_casino: "มินิคาสิโน",
  cash_balance: "ยอดเงินสดคงเหลือ",
  change_account_password: "เปลี่ยนรหัสผ่านบัญชี",
  current_password: "กรุณายืนยันรหัสที่ใช้ปัจจุบัน",
  confirm_new_password: "ยืนยันรหัสในการเข้าระบบ",
  customize_sports_order: "กำหนดคำสั่งด้านกีฬา",
  choice: "รายการ",
  credit: "ได้",
  commission: "คอมมิชชั่น",
  customize: "ปรับแต่ง",
  cancel: "ยกเลิก",
  confirmation: "การยืนยัน",
  closing_balance: "Closing Balance",
  clear_filter: "Clear Filter",
  debit: "เสีย",
  display_language: "ภาษาที่แสดง",
  default_event_sorting: "การเรียงลำดับกิจกรรมตามค่าเริ่มต้น",
  default_stake: "ค่าเดิมพันตั้งต้น",
  date: "วันที่",
  draw: "เสมอ",
  draw_cancel: "เสมอ",
  dec: "DEC",
  double_line: "แถวคู่",
  disable: "ปิดการใช้งาน",
  dec_odds: "การเดิมพันแบบมีทศนิยม",
  id_odds: "แบบอินโด",
  double_chance: "สองโอกาส",
  enable: "เปิด",
  event_sorting: "เรียงลำดับเหตุการณ์",
  esports: "อี-สปอร์ต",
  esports2: "อี-สปอร์ต",
  e_sports: "อี-สปอร์ต",
  edit: "แก้ไข",
  early: "ล่วงหน้า",
  event: "รายการ",
  even: "คู่",
  first_goal: "ประตูแรก",
  first_half: "ผลการแข่งขันครึ่งแรก",
  final: "ผลการแข่งขัน",
  full_time: "เต็มเวลา",
  fold: "พับ",
  first_5_inn: "First 5 Innings",
  games: "เกม",
  given_credit: "ให้เครดิต",
  group: "กลุ่ม",
  goal: "ทำประตู",
  half_time: "ครึ่งแรก",
  hide_header: "หัวข้อ",
  hk: "HK",
  hk_odds: "แบบฮ่องกง",
  home: "หน้าแรก",
  id: "ID",
  inactive: "Inactive",
  inplay: "In-Play",
  keno: "คีโน่",
  kickoff: "ที่เริ่มแข่งขัน",
  lottery: "ลอตเตอรี",
  login: "เข้าสู่ระบบ",
  logout: "ออกจากระบบ",
  last_login: "การเข้าสู่ระบบครั้งล่าสุด",
  last_transaction: "รายการเล่นสุดท้าย",
  live_streaming: "เปิดให้บริการถ่ายทอดสด",
  live_tv: "ถ่ายทอดสดทางทีวี",
  live_match: "การจับคู่ถ่ายทอดสด",
  live: "สด",
  live_center: "ศูนย์สด",
  livecasino: "คาสิโนสด",
  loss: "แพ้",
  lost: "เสีย",
  lose: "เสีย",
  lose_half: "เสียครึ่ง",
  last_bet: "เดิมพันสุดท้าย",
  last_goal: "ประตูสุดท้าย",
  mobile: "สมาร์ทแอฟ",
  message: "ข้อความ",
  my_bet: "บิลเดิมพัน",
  my_favorites: "รายการโปรดของฉัน",
  market_type: "ประเภทตลาด",
  match: "รายการแข่งขัน",
  message_history: "ประวัติข้อมูลที่บันทึก",
  my: "MY",
  market: "ตลาด",
  main_markets: "ตลาดหลัก",
  my_odds: "แบบมาเลย์",
  min: "ขั้นต่ำ",
  max: "สูงสุด",
  max_payout: "จ่ายสูงสุด",
  main: "หลัก",
  corners: "เตะมุม/การ์ด",
  specials: "สเปเชี่ยล",
  mix_parlay: "มิกซ์ พาร์เลย์",
  moneyline: "มันนี่ไลน์",
  no_goal: "ไม่มีประตู",
  normal_announcements: "ประกาศปกติ",
  nickname: "ตั้งชื่อเล่น",
  new_password: "รหัสผ่านใหม่",
  new: "ใหม่",
  "no/": "เบอร์",
  normal_sorting: "เรียงตามลีก",
  other_markets: "การเดิมพันอื่น ๆ",
  outstanding: "การเดิมพันที่ยังไม่สิ้นสุด",
  odds_type: "ประเภทอัตราเดิมพัน",
  odds: "อัตราเดิมพัน",
  opening_balance: "ยอดคงเหลือก่อนหน้านี้",
  outright: "ทายผลผู้ชนะ",
  on: "เปิด",
  off: "ปิด",
  outstanding_bet: "รายการเดิมพันที่เล่นค้างไว้",
  over: "สูง",
  odd: "คี่",
  hdp: "แฮนดิแคป",
  ou: "สูง/ต่ำ",
  oe: "คี่/คู่",
  oxt: "1X2",
  ml: "มันนี่ไลน์",
  password_expiry: "วันหมดอายุของรหัส",
  parlay: "พาร์เลย์",
  page_display: "หน้าที่แสดง",
  page_type: "ประเภทหน้าเว็บ",
  page_size: "ขนาดหน้าเว็บ",
  personal_message: "ข้อความส่วนตัว",
  process_bet: "วางเดิมพัน",
  payout: "จ่าย",
  pending: "กำลังรอ",
  quick_bet: "เดิมพันด่วน",
  quick_bet_stake: "เดิมพันด่วน",
  result: "ผลลัพธ์",
  restore: "ฟื้นฟู",
  remark: "ข้อสังเกตุ",
  ref_no: "Ref. No.",
  remove_from_parlay: "ลบออกจาก parlay",
  remove_from_booster: "ลบออกจาก Booster",
  running: "กำลังเดิมพัน",
  rules: "กฎ",
  rules_regulations: "กฎและกติกา",
  sports: "กีฬา",
  show_balance: "แสดงยอดคงเหลือ",
  statement: "ประวัติการเล่น",
  settings: "ตั้งค่า",
  search_team: "ค้นหาทีม",
  show_header: "โชว์หัวข้อ",
  submit: "ตกลง",
  set_nickname: "ตั้งชื่อเล่น",
  single: "เดียว",
  save: "บันทึก",
  show_score_map: "แสดงแผนผังคะแนน",
  stake: "เงินที่วางเดิมพัน",
  status: "สถานะ",
  sort: "ประเภท",
  sportsbook: "กีฬา",
  sum: "SUM",
  special_announcements: "ประกาศพิเศษ",
  subtotal: "จำนวนรวมย่อย",
  single_line: "แถวเดี่ยว",
  sort_by_time: "เรียงตามเวลา",
  slots: "สล็อต",
  mini_slots: "มินิสล็อต",
  select_leagues: "เลือกลีก",
  settled_amount: "จำนวนเงินที่ชำระ",
  turnover: "ยอดรวมของการเล่น",
  today: "วันนี้",
  time: "เวลา",
  team: "ทีม",
  to: "ถึง",
  trans_time: "หมายเลขบิล",
  total: "จำนวนรวม",
  total_goal: "ประตูรวม",
  treble: "ทริปเปิ้ล",
  transaction_date: "วันที่ทำธุรกรรม",
  transfer_method: "วิธีการโอน",
  transfer: "ตั้งค่าใหม่",
  under: "ต่ำ",
  void: "โมฆะ",
  reject: "ยกเลิก",
  rejected: "ยกเลิก",
  valid_turnover: "เทิร์นโอเวอร์ที่ถูกต้อง",
  win: "ชนะ",
  won: "ชนะ",
  won_half: "ชนะครึ่งหนึ่ง",
  waiting: "กำลังรอ",
  yes: "ใช่",
  no: "ไม่",
  yesterday: "เมื่อวาน",
  monday: "จันทร์",
  tuesday: "อังคาร",
  wednesday: "พุธ",
  thursday: "พฤหัสบดี",
  friday: "ศุกร์",
  saturday: "เสาร์",
  sunday: "อาทิตย์",
  all_league: "ทั้งหมด",
  match_completed: "สมบูรณ์",
  match_pending: "รอผล",
  match_cancelled: "คืนเงิน",
  match_cancelled_1h: "คืนเงิน 1H",
  match_cancelled_2h: "คืนเงิน 2H",
  match_suspended: "ถูกยกเลิก",
  match_suspended_1h: "ถูกยกเลิก 1H",
  match_suspended_2h: "ถูกยกเลิก 2H",
  check_all: "เลือกทั้งหมด",
  selected_only: "ที่เลือกไว้",
  filtered: "กรอง",
  turn_on: "เปิด",
  turn_off: "ปิด",
  preference: "การตั้งค่าของฉัน",
  market_1: "ล่วงหน้า",
  market_2: "วันนี้",
  market_3: "In-Play",
  // asian_handicap: "เอเชี่ยนแฮนดิแคพ",
  // acceptance_countdown: "การยอมรับการตั้งเวลาถอยหลัง",
  // acceptance_rules: "การยอมรับข้อกำหนดทั่วไปและกฎการเดิมพัน",
  // application_betting_rule: "การใช้กฎการเดิมพันทั่วไป",
  // bettype_settlement_rule: "กติกาการตัดสินประเภทการเดิมพัน",
  // change_schedule: "การเปลี่ยนแปลงเวลาตามกำหนดการ",
  // change_venue: "การเปลี่ยนแปลงสถานที่",
  // cons_interpret: "การเรียบเรียงและการตีความ",
  // definition_of_term: "ความหมายของคำศัพท์",
  // general_betting_rule: "กฎการเดิมพันทั่วไป",
  // general_terms: "ข้อกำหนดและเงื่อนไขทั่วไป",
  // general_provision: "บทบัญญัติทั่วไป",
  // general_rules_bt: "กฎกติกาของตลาด (ประเภทการเดิมพัน) กฎกติกาทั่วไป",
  // handicaps: "แฮนดิแคป (HDP), แฮนดิแคปครึ่งแรก และแฮนดิแคปครึ่งหลัง",
  // running_bet_service: "บริการเดิมพันขณะที่กำลังมีการแข่งขัน (เดิมพันสด)",
  // limitation_provision: "การจำกัดความรับผิดชอบและบทบัญญัติสำหรับการชดใช้",
  // match_duration: "ระยะเวลา",
  // member_account: "บัญชีสมาชิก",
  // mixparlays: "มิกซ์ พาร์เลย์",
  // mixparlay_payout: "การจ่ายเงินสูงสุดสำหรับพาร์เลย์ผสม",
  // over_unders: "สูง/ต่ำ (OU), สูง/ต่ำครึ่งแรก สูง/ต่ำครึ่งหลัง",
  // odd_evens: "คี่/คู่ (OE), คี่/คู่ครึ่งแรก คี่/คู่ครึ่งหลัง",
  // rules_governing: "กฎ: กิจกรรมทั่วไปและกิจกรรมเฉพาะ",
  // results: "ผลลัพธ์",
  // software_game: "ซอฟต์แวร์และเกม",
  // single_team_oe: "คู่/คี่ของทีมเดี่ยว",
  // sport_betting_rule: "กฎการเดิมพันกีฬา",
  // terms_of_transact: "ข้อกำหนดการทำธุรกรรม",
  // warranties: "การรับประกันและการรับรองของสมาชิก",
  american_football: "อเมริกันฟุตบอล",
  soccer: "ฟุตบอล",
  basketball: "บาสเกตบอล",
  baseball: "เบสบอล",
  esports: "อี-สปอร์ต",
  tennis: "เทนนิส",

  events: "รายการ",
  brackets: "สาย",
  standing: "กลุ่ม",
  euro2020: "Euro 2020 Table",
  play_now: "Play Now",
  processing: "การประมวลผล...",
  big_small: "ใหญ่/เล็ก",
  odd_even: "คู่/คี่",
  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",
  official_link: "ลิงค์อย่างเป็นทางการ",
  virtual_sports: "กีฬาจำลอง",
  virtual_soccer: "ฟุตบอลอนิเมชั่น",
  virtual_horse_racing: "แข่งม้าเสมือนจริง",
  virtual_dog_racing: "แข่งเกรย์ฮาวด์ออนไลน์",
  virtual_motorsport: "แข่งรถเสมือนจริง",
  prize1: "1ST PRIZE",
  prize2: "2ND PRIZE",
  prize3: "3RD PRIZE",
  round1: "ROUND 1",
  round2: "ROUND 2",
  round3: "ROUND 3",
  round4: "ROUND 4",
  round5: "ROUND 5",
  map1: "Map 1",
  map2: "Map 2",
  map3: "Map 3",
  map4: "Map 4",
  map5: "Map 5",
  map6: "Map 6",
  map7: "Map 7",
  map8: "Map 8",
  map9: "Map 9",
  map10: "MAP 10",

  mini_games: "มินิเกม",

  sysparlay: "เดิมพันระบบ",
  abets: "เดิมพัน",
  afold: "เท่า",

  continue: "ดำเนินการต่อ",
  highlight: "ไฮไลท์",
  show_all_time: "แสดงตลอดเวลา",
  back: "กลับ",
  fishing: "เกมตกปลา",
  upnext: "เกมตกปลา",
  no_video: "ไม่มีวิดีโอ",
  mm_odds: "ความน่าจะเป็น พม่า",
  mmo_parlay: "พม่า พาร์เลย์",
  myanmar: "พม่า",
  combo: "คอมโบ",
  total_bet: "เดิมพันทั้งหมด",
  total_stake: "เงินเดิมพันทั้งหมด",
  total_match: "จำนวนเกม",
  combination: "การรวมกัน",
  stakeperbet: "เดิมพันเดี่ยว",
  total_payout: "การชำระเงินทั้งหมด",
  total_accept: "ยอมรับทั้งหมด",
  total_reject: "ปฏิเสธทั้งหมด",
  sum_wl: "ชนะ/แพ้ทั้งหมด",
  sum_bet: "เดิมพันทั้งหมด",

  abandoned: "ถูกยกเลิก",
  score: "คะแนน",
  winner: "ผู้ชนะ",

  upcoming: "กำลังจะมาถึง",
  ko: "วิธีชนะ",

  adjustment: "การปรับตัว",
  poker: "โป๊กเกอร์"
};
